import { AI_TOOLKIT_MAIN_PANEL_IMAGE_SIZES } from '@app/(main)/(dark)/ai/_shared/_layouts/AiToolkitMainPanel';
import Image, { ImageProps } from 'next/image';
import { JSX } from 'react/jsx-dev-runtime';

import { cn } from '@videoblocks/design-system';

export interface AiToolkitImagePreviewProps extends ImageProps {
    containerClassName?: string;
}

export const AiToolkitImagePreview = ({ containerClassName, ...props }: AiToolkitImagePreviewProps): JSX.Element => {
    return (
        <div
            className={cn(
                'w-full aspect-video relative bg-black rounded-sm border border-white/20 overflow-hidden',
                containerClassName,
            )}
        >
            <Image fill className="object-contain" sizes={AI_TOOLKIT_MAIN_PANEL_IMAGE_SIZES} {...props} />
        </div>
    );
};
